module.exports = {"object":"value","document":{"object":"document","nodes":[{"object":"block","type":"paragraph","nodes":[{"object":"text","text":""}]}]}}


//////////////////
// WEBPACK FOOTER
// ./examples/placeholder/value.json
// module id = 1778
// module chunks = 0